import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, vShow as _vShow, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-lg" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-3 col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, "Filtre", -1)
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card mt-2" }
const _hoisted_7 = { class: "card-group-item" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "form-check form-switch" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "farveSwitch",
  style: {"margin-top":"0.15rem !important"}
}, " Farver ", -1)
const _hoisted_12 = { class: "float-end mt-1" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "card-body"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "form-check" }
const _hoisted_18 = ["id", "value"]
const _hoisted_19 = { class: "form-check-label" }
const _hoisted_20 = { class: "card mt-2" }
const _hoisted_21 = { class: "card-group-item" }
const _hoisted_22 = { class: "card-header" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = { class: "form-check form-switch" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "kategoriSwitch",
  style: {"margin-top":"0.15rem !important"}
}, " Kategorier ", -1)
const _hoisted_26 = { class: "float-end mt-1" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "card-body"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "form-check" }
const _hoisted_32 = ["id", "value"]
const _hoisted_33 = { class: "form-check-label" }
const _hoisted_34 = { class: "col-md-9 col-12" }
const _hoisted_35 = { class: "mt-3" }
const _hoisted_36 = { class: "d-flex" }
const _hoisted_37 = ["onKeypress"]
const _hoisted_38 = { class: "d-flex" }
const _hoisted_39 = { class: "my-1 input-group input-group-sm" }
const _hoisted_40 = { class: "form-check mx-2" }
const _hoisted_41 = ["id", "onUpdate:modelValue"]
const _hoisted_42 = { class: "form-check-label" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "text-end" }, "Nulstil filtre", -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_46 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Indlæser...")
  ])
], -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 2,
  class: "mt-1"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  key: 0,
  class: "mt-3 ms-2"
}
const _hoisted_52 = {
  key: 1,
  class: "mt-3 ms-2"
}
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "mt-2" }

import { useQuery, useResult } from "@vue/apollo-composable";
import {
  FARVER_FOR_KLODS_OPSLAG,
  FARVER_OPSLAG,
  KATEGORIER_FOR_KLODS_OPSLAG,
  KLODS_OPSLAG,
  KLODS_OPSLAG_ANTAL,
  LOKATIONER_OPSLAG
} from "@/constants/graphql";
import { computed, onMounted, ref, Ref, watch } from "vue";
import { Farve } from "@/types/legotyper";
import Klodstabel from "@/components/base/Klodstabel.vue";
import { onBeforeRouteLeave } from "vue-router";
import Pagination from "@/components/base/Pagination.vue";
import { useAuth0 } from "@auth0/auth0-vue";
import Lokationsfilter from "@/components/Lokationsfilter.vue";

interface Optaelling {
  klodsantal: { count: number };
}
interface Farveliste {
  farver: Farve[];
}
interface SoegeFelt {
  navn: string;
  valgt: boolean;
}

interface Filter {
  farver: string[];
  kategorier: string[];
  lokationer: string[];
  soegetekst?: string;
  felter: SoegeFelt[];
  side: number;
  max: number;
}

interface Options {
  enabled: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LegoParts',
  props: {
    farvekode: null,
    soegetekst: null
  },
  setup(__props: any) {

const props = __props as {
  farvekode?: string;
  soegetekst?: string;
}



const { result: farveResult, loading: farveLoading } = useQuery<Farveliste>(
  FARVER_OPSLAG
);
const alleFarver = useResult(farveResult, null, data => data.farver);
const soegtFarve: Farve = computed(() => {
  if (farveLoading.value) return null;
  return alleFarver.value.find(farve => farve.id == props.farvekode);
});

const tekst: Ref<string> = ref("");

function defaultFilter(): Filter {
  return {
    farver: [],
    kategorier: [],
    lokationer: [],
    felter: [
      { navn: "Bricklink", valgt: false },
      { navn: "BrickOwl", valgt: false },
      { navn: "Delnummer", valgt: false },
      { navn: "Element ID", valgt: false },
      { navn: "Lego", valgt: false },
      { navn: "Navn", valgt: true }
    ],
    side: 1,
    max: 100
  };
}

const filternavn = "legoparts.filter";
const filter: Ref<Filter> = ref(defaultFilter());
const knapper: Ref<{
  farver: boolean;
  kategorier: boolean;
  lokationer: boolean;
}> = ref({
  farver: true,
  kategorier: true,
  lokationer: true
});
const accessToken: Ref<string> = ref("");

const colorId = computed(() => {
  if (props.farvekode == undefined || props.farvekode.trim().length == 0) {
    return undefined;
  } else {
    return props.farvekode;
  }
});

const beregnetVariable = computed(() => {
  const variables: {
    colorId?: string;
    lokationer?: string[];
    medDifference?: string;
    soegBricklink?: string;
    soegBrickowl?: string;
    soegElement?: string;
    soegLego?: string;
    soegNavn?: string;
    soegRebrickable?: string;
    valgteKategorier?: string[];
    valgteLokationer?: string[];
    valgteFarver?: string[];
    offset: number;
  } = { offset: 0 };
  if (colorId.value) {
    variables.colorId = colorId.value;
  }
  if (filter.value.lokationer.length > 0) {
    variables.valgteLokationer = filter.value.lokationer;
    variables.medDifference = "0";
  }
  if (filter.value.farver?.length > 0) {
    variables.valgteFarver = filter.value.farver;
  } else if (colorId.value != undefined && !farveLoading.value) {
    variables.valgteFarver = [soegtFarve.value?.navn];
  }
  if (filter.value.kategorier?.length > 0) {
    variables.valgteKategorier = filter.value.kategorier;
  }
  if (
    filter.value?.felter.find(felt => felt.navn === "Bricklink" && felt.valgt)
  ) {
    variables.soegBricklink = filter.value.soegetekst;
  }
  if (
    filter.value?.felter.find(felt => felt.navn === "BrickOwl" && felt.valgt)
  ) {
    variables.soegBrickowl = filter.value.soegetekst;
  }
  if (
    filter.value?.felter.find(felt => felt.navn === "Element ID" && felt.valgt)
  ) {
    variables.soegElement = filter.value.soegetekst;
  }
  if (filter.value?.felter.find(felt => felt.navn === "Lego" && felt.valgt)) {
    variables.soegLego = filter.value.soegetekst;
  }
  if (
    filter.value?.felter.find(felt => felt.navn === "Delnummer" && felt.valgt)
  ) {
    variables.soegRebrickable = filter.value.soegetekst;
  }
  if (filter.value?.felter.find(felt => felt.navn === "Navn" && felt.valgt)) {
    variables.soegNavn = filter.value.soegetekst;
  }
  variables.offset = (Math.max(filter.value.side, 1) - 1) * filter.value.max;
  return variables;
});

const { result: klodsResult, loading: klodsLoading } = useQuery(
  KLODS_OPSLAG,
  () => {
    return { ...filter.value, ...beregnetVariable.value };
  },
  () => {
    const options: Options = {
      enabled: false
    };
    const enabled =
      accessToken.value != undefined && accessToken.value.trim().length > 0;
    options.enabled = enabled;
    return options;
  }
);
const { result: klodsAntal, loading: klodsAntalLoading } = useQuery<Optaelling>(
  KLODS_OPSLAG_ANTAL,
  () => {
    return { ...filter.value, ...beregnetVariable.value };
  },
  () => {
    const options: Options = {
      enabled: false
    };
    const enabled =
      accessToken.value != undefined && accessToken.value.trim().length > 0;
    options.enabled = enabled;
    return options;
  }
);

const { result: klodsFarverResult, loading: klodsFarverLoading } = useQuery(
  FARVER_FOR_KLODS_OPSLAG,
  () => {
    return { ...filter.value, ...beregnetVariable.value };
  },
  () => {
    const options: Options = {
      enabled: false
    };
    const enabled =
      accessToken.value != undefined && accessToken.value.trim().length > 0;
    options.enabled = enabled;
    return options;
  }
);

const { result: kategoriResult, loading: kategoriLoading } = useQuery(
  KATEGORIER_FOR_KLODS_OPSLAG,
  () => {
    return { ...filter.value, ...beregnetVariable.value };
  },
  () => {
    const options: Options = {
      enabled: false
    };
    const enabled =
      accessToken.value != undefined && accessToken.value.trim().length > 0;
    options.enabled = enabled;
    return options;
  }
);

const { result: lokationResult, loading: lokationLoading } = useQuery(
  LOKATIONER_OPSLAG,
  {},
  () => {
    const options: Options = {
      enabled: false
    };
    const enabled =
      accessToken.value != undefined && accessToken.value.trim().length > 0;
    options.enabled = enabled;
    return options;
  }
);

const soegteKlodser = useResult(klodsResult, [], data => data.klodser);
const antalSoegteKlodser = useResult(
  klodsAntal,
  -1,
  data => data.klodsantal.count
);
const farver = useResult(klodsFarverResult, null, data => data.farver);

const kategorier = useResult(kategoriResult, null, data => data.kategorier);

const lokationer = useResult(
  lokationResult,
  null,
  data => data.muligePlaceringer
);

const antal = computed(() => {
  return klodsAntalLoading.value ? -1 : antalSoegteKlodser.value;
});
const altIndlaest = computed(() => {
  return antal.value <= filter.value.max;
});
const indlaeser = computed(() => {
  return klodsLoading.value;
});

const taeller = computed(() => {
  return klodsAntalLoading.value;
});
const antalSider = computed(() => {
  if (taeller.value) {
    return 0;
  } else {
    return Math.ceil(antalSoegteKlodser.value / filter.value.max);
  }
});
const start = computed(() => {
  if (taeller.value) {
    return undefined;
  } else {
    return (filter.value.side - 1) * filter.value.max + 1;
  }
});
const slut = computed(() => {
  if (taeller.value) {
    return undefined;
  } else {
    return Math.min(
      filter.value.side * filter.value.max,
      antalSoegteKlodser.value
    );
  }
});
const farverValgt = computed(() => {
  return !farveLoading.value && filter.value.farver.length > 0;
});
const kategorierValgt = computed(() => {
  return !kategoriLoading.value && filter.value.kategorier.length > 0;
});
const lokationerValgt = computed(() => {
  return !lokationLoading.value && filter.value.lokationer.length > 0;
});

function gemFiltre() {
  localStorage.setItem(filternavn, JSON.stringify(filter.value));
}
function nulstilFarvefilter() {
  filter.value.farver = [];
}
function nulstilAlleFiltre() {
  filter.value = defaultFilter();
  tekst.value = "";
  gemFiltre();
}
function nulstilKategorifilter() {
  filter.value.kategorier = [];
}
function nulstilLokationfilter() {
  filter.value.lokationer = [];
}

function soeg() {
  filter.value.soegetekst =
    tekst.value?.trim()?.length > 0 ? tekst.value : undefined;
}

function soegetekstMedSpecialtegn(tekst: string) {
  return tekst.replace(/\[|\]|\||\.|\(|\)|\*|\+/g, function(x) {
    return "\\" + x;
  });
}
function saetTekst(nyTekst: string) {
  tekst.value = soegetekstMedSpecialtegn(nyTekst);
  filter.value.felter = filter.value.felter.map(element =>
    element.navn == "Navn" ? { ...element, valgt: true } : element
  );
  soeg();
}
function onEnter(event: KeyboardEvent) { // eslint-disable-line
  soeg();
}
function sideskift(side: number): void {
  filter.value.side = side;
}

function opdaterLokationer(valgteLokationer: string[]) {
  filter.value.lokationer = valgteLokationer;
}

function kontrastfarveClass(farvetekst: string): string {
  const luma: number =
    0.2126 * parseInt(farvetekst.substring(0, 2), 16) +
    0.7152 * parseInt(farvetekst.substring(2, 4), 16) +
    0.0722 * parseInt(farvetekst.substring(4, 6), 16);
  return luma >= 165 ? "text-dark" : "text-light";
}

onMounted(async () => {
  const value = localStorage.getItem(filternavn);
  if (value) {
    filter.value = JSON.parse(value);
    tekst.value = filter.value.soegetekst ? filter.value.soegetekst : "";
  }
  if (props.soegetekst != undefined && props.soegetekst.trim().length > 0) {
    tekst.value = soegetekstMedSpecialtegn(props.soegetekst);
    filter.value = defaultFilter();
    filter.value.soegetekst = tekst.value;
  }
  const tokenKey = "accesstoken";
  await useAuth0()
    .getAccessTokenSilently()
    .then(response => {
      accessToken.value = response;
      localStorage.setItem(tokenKey, response);
    })
    .catch(error => {
      console.error("Fejl ved hent af token: " + error);
      localStorage.removeItem(tokenKey);
      accessToken.value = "";
    });
});

onBeforeRouteLeave(() => {
  gemFiltre();
});

watch(tekst, streng => {
  if (streng?.length == 0) soeg();
});

watch(antalSider, antal => {
  if (antal < filter.value.side) {
    filter.value.side = Math.max(antal, 1);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Lokationsfilter, {
            lokationer: filter.value.lokationer,
            onUpdate: opdaterLokationer
          }, null, 8, ["lokationer"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("article", _hoisted_7, [
            _createElementVNode("header", _hoisted_8, [
              _createElementVNode("h6", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "farveSwitch",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((knapper.value.farver) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, knapper.value.farver]
                  ]),
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      class: "btn-close btn-sm",
                      onClick: nulstilFarvefilter,
                      disabled: !_unref(farverValgt)
                    }, null, 8, _hoisted_13)
                  ])
                ])
              ])
            ]),
            (knapper.value.farver)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_unref(klodsFarverLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Indlæser... "))
                    : (_openBlock(), _createElementBlock("form", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(farver), (farve) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: farve.id
                          }, [
                            _createElementVNode("label", _hoisted_17, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: farve.navn,
                                value: farve.navn,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.farver) = $event))
                              }, null, 8, _hoisted_18), [
                                [_vModelCheckbox, filter.value.farver]
                              ]),
                              _createElementVNode("span", _hoisted_19, _toDisplayString(farve.navn), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("article", _hoisted_21, [
            _createElementVNode("header", _hoisted_22, [
              _createElementVNode("h6", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "kategoriSwitch",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((knapper.value.kategorier) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, knapper.value.kategorier]
                  ]),
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("button", {
                      class: "btn-close btn-sm",
                      onClick: nulstilKategorifilter,
                      disabled: !_unref(kategorierValgt)
                    }, null, 8, _hoisted_27)
                  ])
                ])
              ])
            ]),
            (knapper.value.kategorier)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  (_unref(kategoriLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, " Indlæser... "))
                    : (_openBlock(), _createElementBlock("form", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(kategorier), (kategori) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: kategori.id
                          }, [
                            _createElementVNode("label", _hoisted_31, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: kategori.navn,
                                value: kategori.navn,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filter.value.kategorier) = $event))
                              }, null, 8, _hoisted_32), [
                                [_vModelCheckbox, filter.value.kategorier]
                              ]),
                              _createElementVNode("span", _hoisted_33, _toDisplayString(kategori.navn), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_36, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control me-2",
                type: "search",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tekst).value = $event)),
                onKeypress: _withKeys(onEnter, ["enter"]),
                placeholder: "Delnummer, titel eller element ID..."
              }, null, 40, _hoisted_37), [
                [_vModelText, tekst.value]
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: soeg,
                type: "button"
              }, " Søg ")
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.value.felter, (felt) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: felt.navn
                }, [
                  _createElementVNode("label", _hoisted_40, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: felt.navn,
                      "onUpdate:modelValue": ($event: any) => ((felt.valgt) = $event)
                    }, null, 8, _hoisted_41), [
                      [_vModelCheckbox, felt.valgt]
                    ]),
                    _createElementVNode("span", _hoisted_42, _toDisplayString(felt.navn), 1)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", { class: "float-end text-end col-2 mt-1" }, [
              _createElementVNode("button", {
                class: "btn btn-link btn-sm",
                onClick: nulstilAlleFiltre
              }, _hoisted_44)
            ])
          ]),
          (props.farvekode && !_unref(farveLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createVNode(_component_router_link, {
                  class: _normalizeClass(
                'badge text-decoration-none shadow-sm ' +
                  kontrastfarveClass(_unref(soegtFarve).rgb)
              ),
                  style: _normalizeStyle({ 'background-color': '#' + _unref(soegtFarve).rgb }),
                  role: "button",
                  to: { name: 'parts', params: {} }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'xmark'] }),
                    _createTextVNode(" " + _toDisplayString(_unref(soegtFarve).navn), 1)
                  ]),
                  _: 1
                }, 8, ["class", "style"])
              ]))
            : _createCommentVNode("", true),
          (_unref(indlaeser))
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, _hoisted_48))
            : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                (!_unref(taeller))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      (!_unref(altIndlaest))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_51, [
                            _createTextVNode(" Klods " + _toDisplayString(_unref(start)), 1),
                            _withDirectives(_createElementVNode("span", null, "-" + _toDisplayString(_unref(slut)), 513), [
                              [_vShow, _unref(start) < _unref(slut)]
                            ]),
                            _createTextVNode(" (ud af " + _toDisplayString(_unref(antal)) + ") ", 1),
                            _createVNode(Pagination, {
                              "antal-sider": _unref(antalSider),
                              "per-side": filter.value.max,
                              side: filter.value.side,
                              onSideskift: _cache[5] || (_cache[5] = side => sideskift(side))
                            }, null, 8, ["antal-sider", "per-side", "side"])
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_52, "Fundet " + _toDisplayString(_unref(antal)), 1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_53, "   ")),
                _createVNode(Klodstabel, {
                  klodsliste: _unref(soegteKlodser),
                  "vis-overskrift": true,
                  onSoegKlodsnavn: _cache[6] || (_cache[6] = navn => saetTekst(navn))
                }, null, 8, ["klodsliste"]),
                _createElementVNode("div", _hoisted_54, [
                  (!_unref(altIndlaest))
                    ? (_openBlock(), _createBlock(Pagination, {
                        key: 0,
                        "antal-sider": _unref(antalSider),
                        "per-side": filter.value.max,
                        side: filter.value.side,
                        onSideskift: _cache[7] || (_cache[7] = side => sideskift(side))
                      }, null, 8, ["antal-sider", "per-side", "side"]))
                    : _createCommentVNode("", true)
                ])
              ]))
        ])
      ])
    ])
  ]))
}
}

})